import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import NewYearScreen from './newyear'

import HomeScreen from './home';
function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const { change, getInitData} = useRefresh();
    const [showDetailProduct, setShowDetailProduct] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [showHome, setShowHome] = useState(false);
    const [showNewYear, setShowNewYear] = useState(false);
    const [menus, setMenus] = useState([]);
 const [valentine, setvalentine] = useState([]);
 const [datakarol, setdatakarol] = useState(false);
     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    
       useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



    useEffect(() => {
    if (valentine) {
      valentine.map((item) => {
       
          if (item.id === 4060) {
          setdatakarol(item);
          }
         
      });
    }
    }, [valentine]);
    

     useEffect(() => {
            console.log(goHomeInit, 'q mas qlq')
         setShowHome(false)
         setShowNewYear(false)
     }, [goHomeInit]);
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
           setShowHome(false)
           setShowNewYear(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
       useEffect(() => {
            menus.map((item) => {
                
                if (item.id === 497) {
                    setvalentine(item.menus);
                }
               
            });
       }, [menus]);
    
    

    return (
        <LayoutContent showBack={false} showFooter={false} showImageTop={true} setShowSpecials={() => {
            
        }} goCategories={null}>
            <div>
                <div style={{ width: '100%' }}>
                    <div onClick={() => {
                        setShowHome(true)
                    //         setShowDetailProduct(true)
                    // setDataDish({ dish: datakarol, alldish: valentine, currentDish: datakarol })
                        }}>
                        <img
                        style={{
                            width: 600,
                            height: 820,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                                borderRadius: 40,
                            marginTop: 20
                            
                        }}
                            //src={require('./assets/screenbrunch.png')}
                            src={require('./assets/menubotones.jpg')}
                    />
                    </div>


                    {/* <div
                        onClick={() => setShowHome(true)}
                        style={{
                            backgroundColor: '#a21b1b', // rojo oscuro
                            width: '30%',
                            margin: "20px auto",
                            padding: '15px 24px',
                            borderRadius: '9999px', // pill shape
                            border: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                            cursor: 'pointer',
                        }}
                        >
                        <p style={{
                            color: '#fff',
                            fontWeight: 'bold',
                            fontFamily: "RoadStore", // similar a un estilo western
                            fontSize: '18px',
                       }}> TAP FOR MENU</p>
                        </div> */}
                </div>
            </div>

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}

            {showHome && <HomeScreen />}
             {showNewYear && <NewYearScreen  />}
            
        </LayoutContent>
    );
}

export default Index;